export const defaultCenter = {
  lat: 0,
  lng: 0,
};
export const defaultZoomLevel = 2;
